import ToolbarTreeMenuMutations from "./ToolbarTreeMenuMutations";
import ToolbarTreeMenuGetters from "./ToolbarTreeMenuGetters";
import ToolbarTreeMenuActions from "./ToolbarTreeMenuActions";

const { getters } = ToolbarTreeMenuGetters;

const state = { menu: [] };

const { actions } = ToolbarTreeMenuActions;

const { mutations } = ToolbarTreeMenuMutations;

const namespaced = true;

export default {
	state,
	actions,
	mutations,
	namespaced,
	getters,
};
